import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

import { AuthMethodsType } from "components/molecules/LoginForm";

const REG_PARAM_MAPPING = {
  "1": "email",
  "2": "socials",
  "3": "phone",
};

export const useAuthMethods = () => {
  const [searchParams] = useSearchParams();
  const [availableMethods, setAvailableMethods] = useState<string[]>([]);
  const [availableMethodsFromUrl, setAvailableMethodsFromUrl] = useState<
    string[]
  >([]);
  const [authOptionsFromUrl, setAuthOptionsFromUrl] = useState<
    Array<{ id: AuthMethodsType; label: string }>
  >([]);

  useEffect(() => {
    const regParam = searchParams.get("reg");
    const paramToUse = regParam || "123";

    const methodsList: string[] = [];
    const authOptions: Array<{ id: AuthMethodsType; label: string }> = [];

    for (let i = 0; i < paramToUse.length; i += 1) {
      const digit = paramToUse[i];
      const method = REG_PARAM_MAPPING[digit];

      if (method) {
        methodsList.push(method);

        const existingOption = authOptions.find(
          (option) => option.id === (method as AuthMethodsType),
        );

        if (!existingOption) {
          let optionLabel = "Unknown";
          if (method === "email") {
            optionLabel = "Email";
          } else if (method === "socials") {
            optionLabel = "Socials";
          } else if (method === "phone") {
            optionLabel = "Phone";
          }

          authOptions.push({
            id: method as AuthMethodsType,
            label: optionLabel,
          });
        }
      }
    }

    setAvailableMethodsFromUrl(methodsList);
    setAuthOptionsFromUrl(authOptions);
  }, [searchParams]);

  useEffect(() => {
    try {
      const getMethods = async () => {
        const response = await axios.get("/v1/auth/available-methods");

        if (response && response?.data) {
          const backendMethods = response?.data?.availableMethods;

          if (availableMethodsFromUrl.length === 0) {
            setAvailableMethods(backendMethods);
          } else {
            const mappedMethods = {
              email: ["password"],
              socials: ["google", "facebook", "telegram", "instagram"],
              phone: ["phone"],
            };

            const allowedMethods = new Set();
            availableMethodsFromUrl.forEach((method) => {
              if (mappedMethods[method]) {
                mappedMethods[method].forEach((m) => allowedMethods.add(m));
              }
            });

            const filteredMethods = backendMethods?.filter((method) =>
              allowedMethods.has(method),
            );

            setAvailableMethods(filteredMethods);
          }
        }
      };

      getMethods();
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.log("error", error);
    }
  }, [availableMethodsFromUrl]);

  return {
    availableMethods,
    availableMethodsFromUrl,
    authOptionsFromUrl,
  };
};
